module.exports = __webpack_public_path__ + "static/img/id1.9ea31b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/id1.png
// module id = EqaZ
// module chunks = 1